import { render, staticRenderFns } from "./UploadFromDevice.vue?vue&type=template&id=1214459a&"
import script from "./UploadFromDevice.vue?vue&type=script&lang=js&"
export * from "./UploadFromDevice.vue?vue&type=script&lang=js&"
import style0 from "./UploadFromDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports